import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { X } from 'lucide-react';
import { admin as adminApi } from '../utils/api';
import DynamicFormFields from './DynamicFormFields';

const EditClientModal = ({ client, onClose, onSuccess }) => {
  const customData = client.custom_data || {};
  const [formData, setFormData] = useState({
    first_name: client.first_name || '',
    last_name: client.last_name || '',
    email: client.email || '',
    phone: client.phone || '',
    ...customData
  });
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (newData) => {
    setFormData(newData);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    try {
      await adminApi.updateClient(client.id, formData);
      toast.success('Client information updated successfully!');
      if (onSuccess) onSuccess();
    } catch (error) {
      console.error('Update client error:', error);
      toast.error(error.response?.data?.error || 'Failed to update client information');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full max-h-[90vh] overflow-y-auto">
        <div className="flex items-center justify-between p-6 border-b">
          <div>
            <h2 className="text-2xl font-bold text-gray-900">Edit Client Information</h2>
            <p className="text-sm text-gray-600 mt-1">
              Update contact details and notes
            </p>
          </div>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <X size={24} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          <DynamicFormFields
            formData={formData}
            onChange={handleChange}
          />

          {/* Actions */}
          <div className="flex space-x-3 pt-4">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={submitting}
              className="flex-1 px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {submitting ? 'Saving...' : 'Save Changes'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditClientModal;
